commusoftCommon.filter('fullDateTimeFormat', function(CS_LANGUAGE) {
    return function(dateString) {
        if(dateString == ''){
            return '';
        }
        moment.locale(CS_LANGUAGE);
        return moment.utc(dateString).zone(moment().format('Z')).format('dddd Do MMMM YYYY [at] HH:mma')
    };
});